import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { BadgeCheck, ShieldX, ArrowRight } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { Footer } from "../components/Footer";
import api from "../lib/api";

const fmt = (v) => (v ? new Date(v).toLocaleDateString("el-GR", { day: "2-digit", month: "long", year: "numeric" }) : "");

export default function VerifyCertificate() {
  const { serial } = useParams();
  const { t } = useLang();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/verify/${encodeURIComponent(serial)}`).then((r) => setData(r.data)).catch(() => setData({ valid: false }));
  }, [serial]);

  return (
    <>
      <div className="max-w-3xl mx-auto px-5 sm:px-6 pt-16 pb-24" data-testid="verify-page">
        <span className="badge-lime">{t("verify.badge")}</span>
        <h1 className="font-heading font-black text-4xl sm:text-5xl mt-5 text-[#0B1B3A]">{t("verify.title")}</h1>
        <p className="text-sm text-[#64748B] mt-3 font-mono" data-testid="verify-serial">ID: {serial}</p>
        {data === null ? (
          <p className="text-[#64748B] mt-10">{t("common.loading")}</p>
        ) : data.valid ? (
          <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} className="card-dark p-8 sm:p-10 mt-10 border-2 border-[#1D4ED8]" data-testid="verify-valid">
            <div className="flex items-center gap-4">
              <img src="/logo.png" alt="" className="w-14 h-14 object-contain" />
              {data.badge_url && <img src={`${process.env.REACT_APP_BACKEND_URL}${data.badge_url}`} alt="" className="w-28 h-28 object-contain ml-auto" data-testid="verify-course-badge" />}
              <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#DCFCE7] text-[#166534] text-sm font-bold"><BadgeCheck className="w-4 h-4" /> {t("verify.valid")}</span>
            </div>
            <h2 className="font-heading font-black text-2xl sm:text-3xl text-[#0B1B3A] mt-7" data-testid="verify-course">{data.course_title}</h2>
            <p className="text-base text-[#475569] mt-3">{t("certs.holder")}: <strong className="text-[#0B1B3A]" data-testid="verify-holder">{data.holder}</strong></p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mt-7 text-sm">
              <div><p className="text-xs uppercase tracking-[0.14em] text-[#64748B] font-bold">{t("verify.issued")}</p><p className="font-bold text-[#0B1B3A] mt-1">{fmt(data.issued_at)}</p></div>
              <div><p className="text-xs uppercase tracking-[0.14em] text-[#64748B] font-bold">{t("certs.score")}</p><p className="font-bold text-[#0B1B3A] mt-1">{data.score}%</p></div>
              <div><p className="text-xs uppercase tracking-[0.14em] text-[#64748B] font-bold">ID</p><p className="font-bold text-[#0B1B3A] mt-1 font-mono">{data.serial}</p></div>
            </div>
            {data.course_slug && (
              <Link to={`/academy/${data.course_slug}`} className="btn-outline-light mt-8 inline-flex text-sm" data-testid="verify-course-link">{t("certs.openCourse")} <ArrowRight className="w-4 h-4" /></Link>
            )}
          </motion.div>
        ) : (
          <div className="card-dark p-10 mt-10 text-center" data-testid="verify-invalid">
            <ShieldX className="w-12 h-12 text-[#B91C1C] mx-auto" />
            <p className="font-heading font-black text-xl text-[#0B1B3A] mt-5">{t("verify.invalid")}</p>
            <p className="text-sm text-[#64748B] mt-2">{t("verify.invalidHint")}</p>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
}
